import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { getSearch } from '../../utils/http'
import Selected from './Selected'
import Choose from './Choose'
import MajorDetail from './MajorDetail'
import ProfessionDetail from './ProfessionDetail'
import './index.less'
import { getXkCoachBasic} from '../../api/majorWishList';
import {getPurposeSchoolAndSpecialty,} from '../../api/schoolWishList';
import loading from "../../components/Loading";
import {xkCoachLimitSchoolCodes} from '../../constants/constants'

class MajorWishList extends React.Component {

    constructor(props) {
        super(props);
        debugger
        this.state = {
            loading: false,
            // 将selectedMajorList每个元素的code提取出来，组成一个数组
            codes: props.location.state.selectedMajorList.map(i=>i.code)||[],
            disabledOperation:false,
        }
    }


    user_detail=JSON.parse(localStorage.getItem('user_detail'));
    

    componentDidMount() {
        //获取意向学校和专业

        const { codes } = this.state;
        this.setState({
            codes: codes,
        });

        // getPurposeSchoolAndSpecialty(2).then(res => {
        //     //这里注意，新用户的specialties为null，保存过后的空值就变成了[]
        //     if(res.data && res.data.specialties && (getSearch().type !== 'reset')){//res.data.specialties为[]或[...]时代表保存过意向专业
        //         // let codes = res.data.specialties.map(d => d.code)
        //         // console.log("here",codes)
        //         this.setState({
        //             codes: codes,
        //         })
        //     }else {//res.data.specialties为null时代表没有保存过意向专业
        //         // 如果列表为空，从query里取
        //         const searchObj = getSearch();
        //         let codes = searchObj.codes ? searchObj.codes.split(',') : [];
        //         this.setState({
        //             codes: codes
        //         });
        //     }
        //     this.setState({
        //         loading:false
        //     })
        // });
        // getXkCoachBasic().then(res=>{
        //     if(res.code==200){
        //         let isXkCoachLimit=this.user_detail&&this.user_detail.student&&this.user_detail.student.school&&(xkCoachLimitSchoolCodes.includes(this.user_detail.student.school.code)||[35059,974762].includes(this.user_detail.student.userId));
        //         this.setState({
        //             disabledOperation:res.data&&(res.data.status==100)&&isXkCoachLimit,
        //         })
        //     }
        // })
    }

    handleCodesChange(codes = [], type) {
        this.setState(() => {
            return {
                codes,
            }
        });
        const {
            history,
            match
        } = this.props;
        if (type === 'selected') {
            history.replace(match.url + `?codes=${codes.join(',')}`);
        }
        // window.location = window.location.origin + window.location.pathname + `?codes=${codes.join(',')}`;
    }

    render() {
        const { match } = this.props;
        const { codes ,loading,disabledOperation,} = this.state;
        if(loading){
            return <div></div>
        }else {
            return (
                <Switch>
                    <Route exact path={`${match.url}`} render={props =>
                        <Choose codes={codes} disabledOperation={disabledOperation} changeCodes={this.handleCodesChange.bind(this)} {...props} />
                    } />
                    <Route path={`${match.url}/choose`} render={props =>
                        <Choose codes={codes} disabledOperation={disabledOperation} changeCodes={this.handleCodesChange.bind(this)} {...props} />
                    } />
                    <Route path={`${match.url}/major/:id`} render={props =>
                        <MajorDetail codes={codes} disabledOperation={disabledOperation} changeCodes={this.handleCodesChange.bind(this)} {...props} />
                    } />
                    <Route path={`${match.url}/profession/:id`} render={props =>
                        <ProfessionDetail {...props} />
                    } />
                </Switch>
            )
        }
    }
}

export default MajorWishList



// WEBPACK FOOTER //
// ./src/pages/MajorWishListNew/index.js